import { Typography } from "@mui/material";
import React from "react";
import WorkLogReport from "../../models/WorkLogReport";
import { AppDialog } from "../AppDialog";

interface Props {
  worklogReport?: WorkLogReport;
  clearWorklogReport: () => void;
  handleAdjustHours: () => void;
}
const DialogHoursAdjustment = (props: Props) => {
  const { worklogReport, clearWorklogReport, handleAdjustHours } = props;

  if (worklogReport) {
    return (
      <AppDialog
        open={!!worklogReport}
        onClose={() => clearWorklogReport()}
        title={"Hours Adjustment"}
        content={
          <>
            <Typography style={{ fontWeight: "600" }}>{`Use with caution:`}</Typography>
            <Typography>
              {`For using this you need to have weeks that are not approved. This functionality will add extra hours randomly until completing the minimum hours required for the role, are you sure you want do run it for this month?`}
            </Typography>
          </>
        }
        buttons={[{ label: "Confirm", onClick: () => handleAdjustHours() }]}
      />
    );
  } else {
    return <></>;
  }
};
export default DialogHoursAdjustment;
